var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.outerClass},[_c('Tag',{attrs:{"tag":_vm.tag,"size":_vm.size,"type":_vm.type}}),_vm._v(" "),_c('span',{class:_vm.innerClass},[_vm._v(_vm._s(_vm.count))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }